<template>
  <div class="kera-container">
    <table style="width: 100%; height: 98%; font-size: 20px; line-height: normal">
      <tbody>
        <tr style="height: 50px; font-size: 25px">
          <th style="width: 60%; font-weight: bolder" class="border-bottom border-right">
            {{ $t("langcfg.txtName2") }}
          </th>
          <th style="width: 40%; font-weight: bolder" class="border-bottom border-right">
            {{ $t("langcfg.txtValue") }}
          </th>
        </tr>
        <tr v-for="item in keraData" :key="item.key" style="font-size: 23px">
          <td class="border-right border-bottom">
            {{ $t(`langcfg.${item.label}`) }}<br />
            <span style="color: grey">{{ $t(`langcfg.${item.label}tip`) }}</span>
          </td>
          <el-tooltip
            placement="right"
            popper-class="tip"
            manual
            :hide-after="1000"
            v-model="item.selected"
          >
            <div slot="content">
              <span :style="`color:${item.limits[0].color}`">{{ item.limits[0].label }}</span
              >&nbsp;
              <span :style="`color:${item.limits[1].color}`">{{ item.limits[1].label }}</span
              >&nbsp;
              <span :style="`color:${item.limits[2].color}`">{{ item.limits[2].label }}</span>
            </div>
            <td
              class="border-right border-bottom"
              style="cursor: pointer"
              @click.stop.prevent="clickValue(item.key)"
            >
              <span :style="`color:${item.color};`">{{ item.value }}</span>
            </td>
          </el-tooltip>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { MAJMEDIANMODES } from "../shared/index";
import { paramNormal } from "../../shared/filters";
import { getKeraColor, getKeraLimits } from "../shared/util";
import { objectCopy } from "../../shared/utils";
import { Message } from "../../mixins";
import EVENTS from "../../bus";
const KEYS = ["SAI", "SRI", "SDP", "DSI", "OSI", "CSI", "IAI", "KPI", "IS", "KISA"];
export default {
  name: "MeridianFigure",
  data() {
    return {
      options: MAJMEDIANMODES,
      option: MAJMEDIANMODES.ecc,
      keraData: []
    };
  },
  // 0.Q 1.P - VAL  2.E 3.ecc 4.SAGCURV
  mounted() {
    this.getKeraData();
    this.$bus.$on(EVENTS.showSettings, () => {
      for (let i = 0; i < this.keraData.length; i++) {
        this.keraData[i].selected = false;
      }
    });
  },
  watch: {
    "$i18n.locale": {
      deep: true,
      handler(val) {
        this.getKeraData();
      }
    }
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    mapValues: {
      type: Object
    }
  },
  mixins: [Message],
  methods: {
    getKeraData() {
      this.keraData = [];
      if (!this.mapValues) {
        this.message(this.$t("langcfg.txtProcFailed"), "error");
        return;
      }
      const { params } = this.mapValues || { params: {} };
      KEYS.forEach((key) => {
        let para = objectCopy(params[key]);
        // if (key === 'KISA') {
        //   params[key].value = 0.25
        // }
        para.value = paramNormal((params[key] || { value: -1000 }).value);
        para.color = getKeraColor((params[key] || { value: -1000 }).value, key);
        para.limits = getKeraLimits(key);
        para.selected = false;
        para.hideTipTimeout = null;
        this.keraData.push(para);
      });
    },
    filterHandle(v) {
      return paramNormal(v);
    },
    clickValue(key) {
      for (let i = 0; i < this.keraData.length; i++) {
        if (this.keraData[i].key === key) {
          this.keraData[i].selected = !this.keraData[i].selected;
        }
        if (this.keraData[i].selected) {
          if (!this.keraData[i].hideTipTimeout) {
            this.keraData[i].hideTipTimeout = setTimeout(() => {
              this.keraData[i].selected = false;
            }, 5000);
          }
        } else if (this.keraData[i].hideTipTimeout) {
          clearTimeout(this.keraData[i]);
          this.keraData[i].hideTipTimeout = null;
        }
      }
    }
  }
};
</script>
<style scoped>
.kera-container {
  height: 100%;
  width: 100%;
}
.border-right {
  border-right: 1px solid rgba(184, 180, 180, 0.2);
}
.border-bottom {
  border-bottom: 1px solid rgba(184, 180, 180, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/topography/components/KeratoconusStd.vue